import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const AcceptanceModal = ({ document, onClose, onAccept }) => {
  const [hasRead, setHasRead] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);

  const handleAccept = async () => {
    if (!hasRead) return;
    
    setIsAccepting(true);
    try {
      // In real app, save acceptance to database
      await new Promise(resolve => setTimeout(resolve, 500));
      onAccept?.(document);
      onClose();
    } catch (error) {
      console.error('Error accepting document:', error);
    } finally {
      setIsAccepting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-lg max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="text-2xl font-bold text-foreground mb-1">
              Accept {document?.title}
            </h2>
            <p className="text-sm text-muted-foreground">
              Version {document?.version} • Last updated {document?.lastUpdated}
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="space-y-6">
            {document?.sections?.map(section => (
              <div key={section?.id}>
                <h3 className="font-semibold text-foreground mb-2">{section?.title}</h3>
                <p className="text-foreground leading-relaxed whitespace-pre-line">
                  {section?.content}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-border bg-muted/30">
          <div className="flex items-start gap-3 mb-4">
            <Checkbox
              checked={hasRead}
              onChange={(e) => setHasRead(e?.target?.checked)}
              id="accept-terms"
            />
            <label htmlFor="accept-terms" className="text-sm text-foreground cursor-pointer">
              I have read and agree to the {document?.title}. I understand that this document is compliant with {document?.complianceStandards?.join(', ')} regulations.
            </label>
          </div>
          <div className="flex items-center gap-3">
            <Button
              onClick={onClose}
              variant="outline"
              className="flex-1"
            >
              Cancel
            </Button>
            <Button
              onClick={handleAccept}
              disabled={!hasRead || isAccepting}
              className="flex-1"
            >
              {isAccepting ? 'Accepting...' : 'Accept & Continue'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcceptanceModal;